{
  "Earlier": "PRECEDENTI",
  "newNotification": "{newCount} nuova notifica",
  "newNotifications": "{newCount} nuove notifiche",
  "noNotifications": "Riceverai informazioni importanti sui nostri prodotti, sulla collaborazione con gli altri utenti e altri aggiornamenti rilevanti",
  "noNotificationsTitle": "Le notifiche appariranno qui"
}
